import wednesdayImg from '../images/wednesday-addams.jpg';
import enidImg from '../images/enid.jpg'
import thingImg from '../images/thing.jpg'

const cardsData = [
    {
      title: "Wednesday Addams",
      image: wednesdayImg,
      description: "Spooky but stylish.",
    },
    {
        title: "Enid Sinclair",
        image: enidImg,  // if using public/ folder
        description: "Bright and bubbly werewolf.",
      },
      {
        title: "Thing",
        image: thingImg,
        description: "Just a helpful hand.",
      },
    ];

export default cardsData;